import intl from 'react-intl-universal'
import oembedOptions from '../oembedOptions'

export default function (oEmbedUrl) {
  return {
    type: 'reference',
    title: `Social`,
    icon: `share-square`,
    template: `<div contenteditable="false">
               <div contenteditable="false" class="cover"> &nbsp;</div>
               <div ng-show="!feature.referent.id" contenteditable="false" class="alert alert-warning" role="alert">
               ${intl.get('blocks.socialUrl.error.warning')} ${intl.get(
      'blocks.socialUrl.error.noValue'
    )}
               </div>
               <iframe 
                 ng-show="feature.referent.id" 
                 data-oid="{{feature._id}}" 
                 style="width:100%;height:100px" 
                 ng-src="{{${oEmbedUrl}}} />
             </div>`,
    propertyTemplate: `<div>
              <div class="pb-2">To see a list of supported embeds, click <a href="https://redirector.arcpublishing.com/alc/arc-products/ellipsis/user-docs/ellipsis-supported-oembeds/" target="blank">here</a>.</div>
              <div contenteditable="false" class="input-group">
                <label class="input-group-addon">Social Url: </label>
                <input
                  class="form-control"
                  type="text"
                  ng-model="feature.referent.id"
                  placeholder="EX: https://twitter.com/" />
              </div>
            </div>`,
    initialInflation: function () {
      return {
        type: 'reference',
        referent: {
          service: 'oembed',
          provider: '',
          id: '',
        },
      }
    },
    beforeSave: function (ansObj) {
      let addedReferent = false
      for (const i in oembedOptions) {
        if (RegExp(oembedOptions[i][0], 'i').test(ansObj.referent.id)) {
          ansObj.type = 'reference'
          ansObj.referent.type = oembedOptions[i][2]
          ansObj.referent.service = 'oembed'
          ansObj.referent.provider = oembedOptions[i][1] + '?url='
          addedReferent = true
          return true
        }
      }
      if (!addedReferent) {
        // TODO: Eric - notifiy there is no match for referent
        return false
      }
    },
    openPropertyTemplateOnAdd: true,
    // properties : {
    //    type: { type: 'String', default: 'reference' },
    //    referent: {
    //        type: { type: 'String', default: 'oembed' },
    //        service: { type: 'String', default: 'oembed' },
    //        provider : { type: 'String', default : 'https://publish.twitter.com/oembed?url=' /*"https://api.twitter.com/1/statuses/oembed.json"*/ },
    //        id : { type: 'String', default : '' /*"https://twitter.com/donniechrismer/status/664448833825304576"*/ }
    //    }
    // }
  }
}
